import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useStoreVsVillagePages from '../useFootfallStoreVsVillage';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    title,
    summary,
    loading,
    handleDownloadExcel,
    searchParams,
    format,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useStoreVsVillagePages();
  const { t } = useTranslation();

  const byCompany = searchParams.get('by_company');
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={'FOOTFALL TREND: STORE vs VILLAGE'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage
          errors={errors}
          searchParams={searchParams}
          shopRequired
        />
        {byCompany && byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col xs={24} xxl={10}>
                <Table
                  columns={UIHelper.assignTire(columns)}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 1200 }}
                  summary={summary}
                  loading={loading}
                />
              </Col>
              <Col xs={24} xxl={14}>
                <BarChangeChart
                  keys={[
                    'Incidenza Ingressi Pdv YTD',
                    'Incidenza Footfall Village YTD',
                  ]}
                  data={data}
                  format={format}
                  lineItemWidth={200}
                  itemWidth={200}
                  translateX={250}
                  translateXBar={-140}
                  lineColors={['#f1e15b', '#7cf15b']}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
